module.exports = __webpack_public_path__ + "img/ruanzhu2424.df29bea6.png";